module.exports = __webpack_public_path__ + "static/img/scene11.9884d46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene11.jpg
// module id = H/x+
// module chunks = 1